import { useState } from "react";
import { Form } from "antd";

import { type ScheduledEnrollChallengeAutomation } from "@fitness-app/data-models/entities/AutomationTemplate";
import { type ProgramAutomationScheduledTask } from "@fitness-app/data-models/entities/ProgramAutomation";

import { type EnrollChallengeTaskFormModel } from "./types";

// scheduleTiming lives on the ProgramAutomationScheduledTask wrapper, so keep it
// on the edited task to preload the package-anchor fields (TRE-1612).
type EditedEnrollChallengeTask = ScheduledEnrollChallengeAutomation &
  Pick<ProgramAutomationScheduledTask, "scheduleTiming">;

export const useEnrollChallengeTaskForm = () => {
  const [visible, toggleVisibility] = useState(false);
  const [formController] = Form.useForm<EnrollChallengeTaskFormModel>();
  const [editedTask, setTask] = useState<null | EditedEnrollChallengeTask>(null);

  const closeModal = () => {
    toggleVisibility(false);
    setTask(null);
  };

  const openModal = (task?: EditedEnrollChallengeTask) => {
    if (task) {
      setTask(task);
    }
    toggleVisibility(true);
  };

  return {
    visible,
    closeModal,
    openModal,
    editedTask,
    formController,
  };
};
